<template>
  <div>
    <headerNotice routerName="图案资料"></headerNotice>
    <!-- 搜索栏 -->
    <div class="searchBox">
      <el-row :gutter="24">
        <!-- 搜索框 -->
        <el-col :span="5" :offset="0">
          <el-input placeholder="请输入名称" v-model="serachForm.customizationName">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <!-- 标签搜索 -->
        <!-- <el-col :span="4" :offset="0">
          <el-select v-model="serachForm.cateID" @change="tagSearch" placeholder="分类">
            <el-option label="请选择" :value="0"></el-option>
            <el-option
              v-for="item in classifylist"
              :key="item.cateID"
              :label="item.cateName"
              :value="item.cateID"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="3" :offset="0">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col> -->
        <!-- <el-col :span="2" :offset="2">
          <el-button type="primary" @click="add">
            <i class="el-icon-plus"></i> 新增
          </el-button>
        </el-col> -->
      </el-row>
    </div>
    <!-- 数据表格 -->
    <div class="dataTable" v-loading="loading">
      <!-- 多选操作 -->
      <div style="margin-bottom: 20px">
        <span class="notice" v-if="choosedItem.length">
          已经选择
          <i>{{choosedItem.length}}</i> 项
        </span>
        <el-button type="danger" @click="delChoosed()">批量删除</el-button>
          <el-button type="primary" @click="add">
            <i class="el-icon-plus"></i> 新增
          </el-button>
      </div>
      <div class="searchListContent">
        <el-table
          ref="searchListTable"
          :data="quotationlist"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" prop="sort" label="排序"></el-table-column>
          <el-table-column align="center" prop="customizationID" label="编号"></el-table-column>
          <el-table-column align="center" label="图案">
              <template slot-scope="scope">
                        <img :src="baseUrl+scope.row.customizationImageUrl" alt width="100" height="100">
                    </template>
          </el-table-column>
          <el-table-column align="center" prop="customizationName" label="图案名称"></el-table-column>
          <!-- <el-table-column align="center" prop="cateName" label="分类"></el-table-column> -->
          <el-table-column align="center" fixed="right" label="操作" width="240">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="onEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="onDel(scope.row)">删除</el-button>
              <el-button type="text" size="small" @click="onDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[25, 50, 75, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
const map = { boolean: { 0: "否", 1: "是" } };
export default {
  data() {
    return {
      baseUrl: this.$store.state.apiUrl,
      loading: true,
      totalCount: 0, //总数据条数
      currentPage: 1,

      quotationlist: [], //列表主数据

      serachForm: {
        maxResultCount: 25, //默认一页显示的个数,
        skipCount: 0,
        customizationType: 1, //图案
        customizationName: "",
        cateID: 0
      }, //查询条件
      classifylist: [], //分类列表
      choosedItem: []
    };
  },
  components: {
    headerNotice
  },

  mounted() {
    this.getDatas(this.serachForm);
    this.getclassifylist({
      customizationType: 1
    });
  },
  methods: {
    //获取列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCustomization/GetPageList",
        params: params,
        success(res) {
          self.quotationlist = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //获取分类下拉框
    getclassifylist(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCustomizationCate/GetAllByCustomizationType",
        params: params,
        success(res) {
          self.classifylist = res;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },

    //勾选单个表格
    handleSelectionChange(val) {
      this.choosedItem = val;
      console.log(this.choosedItem);
    },

    //查询
    search() {
      this.serachForm.SkipCount = 0;
      let serachForm = this.serachForm;
      this.getDatas(serachForm);
    },

    //新增
    add() {
      this.$router.push({
        path: "/addPattern?type=1" //新增操作
      });
    },
    //编辑
    onEdit(row) {
      this.$router.push({
        path: "/addPattern?type=2&id=" + row.customizationID //编辑操作
      });
    },
    onDetail(row) {
      this.$router.push({
        path: "/addPattern?type=0&id=" + row.customizationID //查看操作
      });
    },
    //单条删除
    onDel(row) {
      let params = "?customizationIDs="+row.customizationID ;
      this.delall(params);
    },
    //批量删除
    delChoosed() {
      if (this.choosedItem.length == 0) {
        this.$message.error("没有勾选项");
        return;
      }
      let customizationIDs = [];
      for (let index = 0; index < this.choosedItem.length; index++) {
        const element = this.choosedItem[index];
        customizationIDs.push(element.customizationID);
      }
      let params = customizationIDs.map(item => {
        return "customizationIDs=" + item;
      });
      params = "?" + params.join("&");
      this.delall(params);
    },
    //删除
    delall(params) {
      let self = this;
      this.$confirm("确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          self.loading = true;
        $http.DELETE({
          url:self.$store.state.apiUrl +
            "/api/services/app/AdminCustomization/Delete"+params,
          //data: params,
          success(res) {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.serachForm.MaxResultCount = self.maxResultCount;
            self.getDatas(self.serachForm);
            self.currentPage = 1;
            self.loading = false;
          },
          fail(res) {
            self.loading = false;
          }
        });
      });
    }
  }
};
</script>

<style lang='scss' scoped>
// 搜索栏
.searchBox {
  padding: 20px;
}
// 数据表格
.dataTable {
  margin: 20px;
  padding-bottom: 0;
  .tableBox {
    border: 1px solid #c5c5c5;
  }
  .goodBaseInfo {
    display: flex;
    align-items: center;
    .txtInfo {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      text-align: left;
      .title {
        font-size: 12px;
        color: #333;
      }
      .itemCode {
        font-size: 10px;
        color: #999;
      }
      .tags {
        display: flex;
        align-items: center;
        span {
          height: 18px;
          line-height: 18px;
          font-style: normal;
          font-size: 10px;
          padding: 0px 8px;
          color: #fff;
          background: #999;
          border-radius: 4px;
          margin-right: 4px;
        }
        /deep/ .el-popover__reference {
          cursor: pointer;
          margin: 0;
          padding: 0;
        }
      }
    }
    img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }
  .notice {
    display: inline-block;
    margin-right: 20px;
    i {
      font-style: normal;
      color: #f63b3b;
    }
  }
}
//高级搜索Dialog框
.searchDialog {
  .sale {
    display: flex;
    align-items: center;
    span {
      display: block;
      width: 125px;
      text-align: right;
      box-sizing: border-box;
      padding-right: 12px;
    }
    input {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100px;
      height: 32px;
      outline: #409eff;
      appearance: normal;
    }
  }
  .searchDialogBtn {
    text-align: center;
  }
}
//批量设置标签dialog框
.setTagsDialog {
  .tagNotice {
    margin-bottom: 20px;
  }
  .tagsDialogBtn {
    text-align: right;
    margin-top: 20px;
  }
}

// 库存详情dialog框
</style>
<style lang="scss">
.goodsListCheckBox {
  display: flex;
  flex-direction: column;
  label {
    margin-left: 0 !important;
  }
}
</style>